document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.getElementById('imw-sticky-atc');
  const originalButton = document.querySelector('.product-form__buttons');

  if (!stickyBar || !originalButton) return;

  function toggleStickyBar() {
    const rect = originalButton.getBoundingClientRect();

    // Show sticky bar when original Add to Cart is out of view
    if (rect.bottom < 0) {
      stickyBar.hidden = false;
      stickyBar.classList.add('show');
    } else {
      stickyBar.classList.remove('show');

      setTimeout(() => {
        if (!stickyBar.classList.contains('show')) {
          stickyBar.hidden = true;
        }
      }, 300);
    }
  }

  window.addEventListener('scroll', toggleStickyBar, { passive: true });
  window.addEventListener('resize', toggleStickyBar);

  toggleStickyBar();
});